import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { getISOWeek, startOfMonth, endOfMonth } from 'date-fns';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';


interface ItemData {
  sId: number;
}

@Component({
  selector: 'app-wmsm-StatementQueryWHQ',
  templateUrl: './wmsm-StatementQueryWHQ.component.html',
  styleUrls: ['./wmsm-StatementQueryWHQ.component.scss']
})
export class WmsmStatementQueryWHQComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  private outer: EventEmitter<any> = new EventEmitter();
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  validateForm: FormGroup;
  formValues: any;
  monthFormat = 'yyyy/MM';
  checked: boolean = false;
  indeterminate = false;
  listdata: [] = [];
  listOfCurrentPageData: readonly ItemData[] = [];
  listOfData: any[] = [];
  setOfCheckedId = new Set<number>();
  selectDisabled: boolean = true;
  BillingStatus: any;
  fixedColumn = true;
  a: [];
  tw: boolean;
  cn: boolean;
  en: boolean;
  otd2_Visible: boolean;
  Role: string;
  disabledQuery: boolean;
  timePromise: any;
  HavaInvoice: string;
  PaNo: string;
  paApplicant: string;


  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
    private notification: NzNotificationService

  ) { super() }

  ngOnInit() {

    this.matomotracker.trackPageView("供應商管理")
    this.matomotracker.trackEvent("供應商管理", "TW对账单查询", "Transation", 1);
    this.validateForm = this.fb.group({
      PONO: [''],
      StatementMonthFrom: [''],
      StatementMonthTo: [''],
      InvoiceNo: [''],
      BillingStatus: [],
      Buyer: [['']],
      applyDept: [''],
      NotInvoice: [''],
      PANO: [''],
      prApplicant: [''],
    });
    this.HavaInvoice = 'Y'
    this.LayoutComponent.geturl()
    this.SelectAllDisabled()
    if (this.formValues == undefined) {
      this.disabledQuery = true
    }
  }


  updateCheckedSet(sId: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(sId);
    } else {
      this.setOfCheckedId.delete(sId);
    }
  }

  onItemChecked(sId: number, checked: boolean): void {
    this.updateCheckedSet(sId, checked);
    this.listOfCurrentPageData[sId];
    this.refreshCheckedStatus();
  }

  onAllChecked(checked: boolean): void {

    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.sId, checked));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: readonly ItemData[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.sId));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.sId)) && !this.checked;
  }




  getFormValue(value): void {
    this.formValues = value;
    this.disabledQuery = false
  }


  onSearch() {

    this.getResultData()
  }

  // 获取查询表格数据
  getResultData() {
    this.loading = true
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetQueryRtStatement.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Buyer: this.formValues.Buyer,
        siteNo: this.formValues.Site,
        vendorCode: this.formValues.Vendor,
        poNo: this.formValues.PONO,
        from: this.getTheDateString_(this.formValues.StatementMonth[0]) || '',
        to: this.getTheDateString_(this.formValues.StatementMonth[1]) || '',
        invoiceNo: this.formValues.InvoiceNo,
        ApplyDept: this.formValues.applyDept,
        QueryStatus: this.formValues.BillingStatus,
        HaveInvoice: this.formValues.NotInvoice,
        PaNo: this.formValues.PANO,
        prApplicant: this.formValues.applyDept
      },
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res.data.length !== 0
        ) {
          this.listOfData = res.data.map((item) => {
            item.invoiceDate = DateUtil.formatYMD(item.invoiceDate);
            item.rtSatementSendDate = DateUtil.formatYMD(item.rtSatementSendDate);
            this.loading = false;
            return item;
          });
          this.nzTotal = res.total;
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
        }

        if (res.data.length == 0) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success('該選擇條件下沒有對賬單信息');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success('该选择条件下没有对账单信息”');
          }
          if (language == 'en') {
            this.NzMessageService.success('No billing information is available under this selection condition');
          }
          this.loading = false;
          return;
        }
        this.GetLanguage();
        this.loading = false
      },
      (error) => {
        debugger
        this.NzMessageService.error(error.msg);
      }

    );

  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }

  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.poNo.localeCompare(b.poNo)
    ) : this.listOfData.sort(
      (a, b) => b.poNo.localeCompare(a.poNo)
    )
  }

  myChange(e) {
    // this.bottomTable.pageNo = e
    this.outer.emit(e)
  }

  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownloadTWQueryStatementExcel.url}`;
    const params = {
      data: {
        Buyer: this.formValues.Buyer,
        siteNo: this.formValues.Site,
        vendorCode: this.formValues.Vendor,
        poNo: this.formValues.PONO,
        from: this.getTheDateString_((this.formValues.StatementMonth[0])) || '',
        to: this.getTheDateString_(this.formValues.StatementMonth[1]) || '',
        invoiceNo: this.formValues.InvoiceNo,
        ApplyDept: this.formValues.applyDept,
        QueryStatus: this.formValues.BillingStatus,
        HaveInvoice: this.formValues.NotInvoice,
        PaNo: this.formValues.PANO,
        prApplicant: this.formValues.applyDept
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.NzMessageService.success('下载成功');
      this.downloadFile8(res, `TWN_Payment_Inquiry_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }

  SelectAllDisabled() {
    if (this.BillingStatus == !'') {
      this.selectDisabled = false;
    }
  }

  GetLanguage() {
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
    }

  }


  // 发送邮件
  SendStatementNotification() {
    this.loading = true
    var data = [];
    this.setOfCheckedId.forEach(x => {
      var dto = this.listOfData.find(o => o.sId == x);
      data.push(dto);
    })
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.SendStatementNotification.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: data.map(x => x.poNo)
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        setTimeout(() => {
          this.getResultData();
        }, 100);
        this.setOfCheckedId.clear();
        this.loading = false;
        if (data != null) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.success('發送成功');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.success('发送成功');
          }
          if (language == 'en') {
            this.NzMessageService.success('Message sent successfully');
          }
          return;
        }
        this.GetLanguage()
        if (params.data.length == 0) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.NzMessageService.error('發送失敗，請勾選數據');
          }
          if (language == 'zh-CN') {
            this.NzMessageService.error('发送失败，请勾选数据');
          }
          if (language == 'en') {
            this.NzMessageService.error('Message sending failure,Please check data');
          }
          return;
        }
        this.GetLanguage()
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }

    );
  }


  GetFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.invoiceElectronic).subscribe(
      (res) => {
        this.downloadFile8(res, data.invoiceElectronicName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  GetOtherFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.otherAttachment).subscribe(
      (res) => {
        this.downloadFile8(res, data.otherAttachmentName);
        this.NzMessageService.success(res.msg);
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  GetBuyerFileTokenOnClick(data) {
    this.WebApiService.downloadFileByToken(data.purchaseAttachment).subscribe(
      (res) => {
        this.downloadFile8(res, data.purchaseAttachmentName);
        this.NzMessageService.success(res.msg);

      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }

  showNote(note: string): void {
    if (note == 'Statistical') {
      this.otd2_Visible = true;
    }
  }

  CloseNote(note: string): void {
    if (note == 'Statistical') {
      this.otd2_Visible = false;
    }
  }

  timer(flag) {      //flag是一个标识，何时计时和何时停止
    var second = 0
    if (flag == 1) {
      this.timePromise = setInterval(
        (success) => { //回掉函数开始计时了
          second++;
          //other actions
        }, 10000);
    }
    else if (flag == 0) {
      //other actions
      //清除计时器
      window.clearInterval(this.timePromise);
    }
  }

  Refresh(type: string) {

    let language = sessionStorage.getItem("wmsmlang");
    if (language == 'zh-TW') {
      this.notification.create(
        type,
        '正在刷新',
        '您可以進行其他操作',

      );
    }
    if (language == 'zh-CN') {
      this.notification.create(
        type,
        '正在刷新',
        '您可以进行其他操作',

      );
    }
    if (language == 'en') {
      this.notification.create(
        type,
        'Refresh',
        'You can do other things',

      );
    }

    const params = {
    }
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.RefreshPA.url}`;
    this.WebApiService.doGet(url, params).subscribe(
      (res) => {
        if (res.status == 200) {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.notification.create(
              'success',
              '刷新成功',
              '刷新成功',
              { nzDuration: 0 }
            );
          }
          if (language == 'zh-CN') {
            this.notification.create(
              'success',
              '刷新成功',
              '刷新成功',
              { nzDuration: 0 }
            );
          }
          if (language == 'en') {
            this.notification.create(
              'success',
              'Refresh successfully',
              'Refresh successfully',
              { nzDuration: 0 }
            );
          }

        } else {
          let language = sessionStorage.getItem("wmsmlang");
          if (language == 'zh-TW') {
            this.notification.create(
              'error',
              '刷新失敗',
              '刷新失敗',
              { nzDuration: 0 }
            );
          }
          if (language == 'zh-CN') {
            this.notification.create(
              'error',
              '刷新失败',
              '刷新失败',
              { nzDuration: 0 }
            );
          }
          if (language == 'en') {
            this.notification.create(
              'error',
              'Refresh failure',
              'Refresh failure',
              { nzDuration: 0 }
            );
          }

        }


      },
      (error) => {

      }
    );
  }

  onQueryClick1(): string {

    return 'StatementQueryWHQ';
  }

}
